var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.state == "fetching"
        ? _c("div", { attrs: { id: "sending" } }, [
            _c("div", { staticClass: "overlay" }),
            _vm._v(" "),
            _c("div", { staticClass: "form-sending" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "reviews",
            adaptive: true,
            scrollable: true,
            reset: true,
            width: "90%",
            maxWidth: 1100,
            height: "auto",
          },
        },
        [
          _c("div", { staticClass: "modal__content" }, [
            _c("div", { staticClass: "modal__header container" }, [
              _vm._v(
                "\n                Keikka-arvostelut - " +
                  _vm._s(_vm.bandName) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gigs-list container" },
              _vm._l(_vm.reviews, function (review) {
                return _c(
                  "div",
                  { key: review.id, staticClass: "row gigs-list__row" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-3 gigs-list__item" },
                      [
                        _c("stars", {
                          attrs: {
                            rating: review.points,
                            "round-stars": false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6 gigs-list__item" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(review.text) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 gigs-list__item" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.formatDate(review.added)) +
                          "\n                    "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal__footer" }, [
              _c(
                "span",
                {
                  staticClass: "btn btn--call-to-action btn--hollow btn--small",
                  on: { click: _vm.closeModal },
                },
                [_vm._v("Sulje")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn--info btn--hollow btn--block",
          on: { click: _vm.openModal },
        },
        [_vm._v("Näytä kaikki arvostelut")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }